class printDiv {

    constructor() {
        this.restrict = 'A';


        this.link = (scope, element, attrs, modelCtrl) => {
            var iframe;
            var elementToPrint = document.querySelector(attrs.printDiv);

            if (!window.frames['print-frame']) {
                var elm = document.createElement('iframe');
                elm.setAttribute('id', 'print-frame');
                elm.setAttribute('name', 'print-frame');
                elm.setAttribute('style', 'display: none;');
                document.body.appendChild(elm);
            }

            function write(value) {
                var doc;
                if (iframe.contentDocument) { // DOM
                    doc = iframe.contentDocument;
                } else if (iframe.contentWindow) { // IE win
                    doc = iframe.contentWindow.document;
                }
                doc.write(value);
                doc.close();
            }

            element.bind('click', function (event) {
                elementToPrint = document.querySelector(attrs.printDiv);
                iframe = document.getElementById('print-frame');
                write(elementToPrint.innerHTML);
                if (window.navigator.userAgent.indexOf('MSIE') > 0) {
                    iframe.contentWindow.document.execCommand('print', false, null);
                } else {
                    iframe.contentWindow.focus();
                    iframe.contentWindow.print();
                }
            });
        }
    }

    static directiveFactory() {
        printDiv.instance = new printDiv();
        return printDiv.instance;
    }
}

export default printDiv;


/** WEBPACK FOOTER **
 ** ./src/app/directives/print/printDiv.js
 **/